import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalSidebar from '../../../components/ModalSidebar';
import { ManageSkillsConnected } from './ManageSkillsConnected';

type Props = {
  visible: boolean;
  onClose: () => void;
};

export const ManageSkillsSidebar: React.FC<React.PropsWithChildren<Props>> = ({
  visible,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <ModalSidebar
      show={visible}
      onClose={onClose}
      header={t('skills.manager.title')}
      content={<ManageSkillsConnected />}
    />
  );
};
